import React from 'react';
import EditableTable from './editableTable';
import { formatNumericDate } from '../../utils/dates';
import { TagNameIcon } from '../Icons/Icons';

export default {
  title: 'Components/EditableTable',
  component: EditableTable,
  argTypes: {
    onUpdate: { action: 'updated' },
    isDeleteEnabled: { control: 'boolean' },
  },
  tags: ['autodocs'],
};

// Default story
const Template = (args) => <EditableTable {...args} />;

export const TagsTable = Template.bind({});
TagsTable.args = {
  dataSource: [
    {
      id: 1,
      name: 'Tag 1',
      date: formatNumericDate('2024-07-01'),
      sites: 10,
    },
    {
      id: 2,
      name: 'Tag 2',
      date: formatNumericDate('2024-07-02'),
      sites: 20,
    },
  ],
  columns: [
    {
      key: 'name',
      header: 'Name',
      isEditable: true,
      width: '35%',
      fontWeight: 'bold',
      shouldDisplayIcon: true,
      icon: TagNameIcon,
    },
    {
      key: 'date',
      header: 'Date',
      isEditable: false,
      width: '25%',
    },
    {
      key: 'sites',
      header: 'Sites',
      isEditable: false,
      width: '20%',
    },
  ],
  isDeleteEnabled: true,
};
